'use client';

import { useEffect } from 'react';
import Error from 'next/error';

type Props = {
  error: Error;
};

function ErrorState({ error }: Props) {
  useEffect(() => {
    console.log('🚀 ~ ErrorState ~ error:', error);
  }, [error]);

  return <Error statusCode={500} title={'Something went wrong!'} />;
}

export default ErrorState;
